import React from 'react';

const Step2 = ({ formData, handleChange, handleCheckboxChange }) => {
  const {
    organizacionNombre,
    organizacionTipoEntidad,
    organizacionPais,
    configProducto,
    configCertificaciones = [],
    configPrivacidadTerminos,
  } = formData;

  const certificaciones = [
    { id: "organica", label: "Orgánica" },
    { id: "comercioJusto", label: "Comercio Justo" },
    { id: "rainforest", label: "Rainforest Alliance" },
    { id: "otra", label: "Otra" },
    { id: "ninguna", label: "Ninguna" },
  ];

  return (
    <>
      {/* INFORMACIÓN GENERAL */}
      <div className="mb-4">
        <h6 className="fw-bold mb-3 d-flex align-items-center text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-building mr-2" style={{ color: '#4a6502' }}></i> Información General
        </h6>
        <div className="row">
          <div className="col-md-12 mb-3">
            <label className="form-label fw-bold">Nombre de la Organización <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-building"></i></span>
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="Ej. Cooperativa Lxs Peluzos"
                name="organizacionNombre"
                value={organizacionNombre || ''}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">País <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-globe"></i></span>
              <select
                className="form-select form-control form-control-sm"
                name="organizacionPais"
                value={organizacionPais || 'mexico'}
                onChange={handleChange}
                required
              >
                <option value="mexico">México</option>
              </select>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Tipo de Entidad</label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-list"></i></span>
              <select
                className="form-control form-control-sm form-select"
                name="organizacionTipoEntidad"
                value={organizacionTipoEntidad || ''}
                onChange={handleChange}
              >
                <option value="">Selecciona una opción</option>
                <option value="cooperativa">Cooperativa</option>
                <option value="empresa">Empresa</option>
                <option value="asociacion">Asociación</option>
                <option value="otra">Otra</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* PRODUCTO */}
      <div className="mb-4">
        <h6 className="fw-bold mb-3 mt-4 d-flex align-items-center text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-leaf mr-2" style={{ color: '#4a6502' }}></i> Producto <span className="text-danger ms-1">*</span>
        </h6>
        <div className="input-group m-b-15">
          <span className="input-group-text"><i className="fa fa-tag"></i></span>
          <select
            className="form-select form-control form-control-md"
            name="configProducto"
            value={configProducto || ''}
            onChange={handleChange}
            required
          >
            <option value="">Selecciona un producto</option>
            <option value="cafe">Café</option>
            <option value="cacao">Cacao</option>
            <option value="miel">Miel</option>
          </select>
        </div>
      </div>

      {/* CERTIFICACIONES */}
      <div className="mb-4">
        <h6 className="fw-bold mb-1 mt-4 d-flex align-items-center text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-certificate mr-2" style={{ color: '#4a6502' }}></i> Certificaciones de la Organización
        </h6>
        <p className="text-muted mb-3" style={{ fontSize: '0.8rem' }}>Selecciona todas las que apliquen</p>
        <div className="d-flex flex-wrap" style={{ gap: '12px' }}>
          {certificaciones.map((cert) => (
            <label
              key={cert.id}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '16px 24px',
                backgroundColor: '#F8FAFC',
                border: '1px solid #ddd',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '0.85rem',
                userSelect: 'none',
                transition: 'all 0.2s ease',
              }}
            >
              <input
                type="checkbox"
                checked={configCertificaciones.includes(cert.id)}
                onChange={() => handleCheckboxChange('configCertificaciones', cert.id)}
                style={{ width: '16px', height: '16px', margin: 0, cursor: 'pointer', flexShrink: 0, accentColor: '#526b08' }}
              />
              {cert.label}
            </label>
          ))}
        </div>
      </div>

      {/* LOGOTIPO */}
      <div className="mb-4">
        <h6 className="fw-bold mb-1 mt-4 d-flex align-items-center text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-image mr-2" style={{ color: '#4a6502' }}></i> Logotipo
        </h6>
        <p className="text-muted mb-3" style={{ fontSize: '0.8rem' }}>(Opcional) Puedes omitir este paso y compartirlo con nosotros más adelante.</p>
        <div className="border rounded d-flex flex-column align-items-center justify-content-center py-4 bg-light" style={{ borderStyle: 'dashed !important', cursor: 'pointer', borderColor: '#dee2e6' }}>
          <i className="fa fa-cloud-upload-alt fs-2 mb-2 text-muted"></i>
          <span className="text-muted">Seleccionar imagen</span>
        </div>
      </div>

      {/* TÉRMINOS Y PRIVACIDAD */}
      <div className="mb-4 mt-5">
        <div className="card border-0" style={{ borderRadius: '10px', padding: '20px', background: '#F8FAFC' }}>
          <div className="form-check">
            <input
              className="form-check-input"
              id="configPrivacidadTerminos"
              type="checkbox"
              name="configPrivacidadTerminos"
              checked={configPrivacidadTerminos || false}
              onChange={(e) => handleChange({ target: { name: 'configPrivacidadTerminos', value: e.target.checked } })}
              required
            />
            <label className="form-check-label ms-2" htmlFor="configPrivacidadTerminos" style={{ fontSize: '0.85rem' }}>
              He leído y acepto el{' '}
              <a href="#" style={{ color: '#526b08', fontWeight: 'bold', textDecoration: 'underline' }}>
                Aviso de Privacidad
              </a>{' '}
              y los{' '}
              <a href="#" style={{ color: '#526b08', fontWeight: 'bold', textDecoration: 'underline' }}>
                Términos y Condiciones
              </a>.
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step2;
